export enum FunctionName {
  GetLibraryName,
  GetFolderName,
  GetParentField,
  GetSite,
  GetSiteCollection,
  GetSubfolders
}

export const FunctionNameName = new Map<number, string>([
  [FunctionName.GetLibraryName, "getLibraryName"],
  [FunctionName.GetFolderName, "getFolderName"],
  [FunctionName.GetParentField, "getParentField"],
  [FunctionName.GetSite, "getSite"],
  [FunctionName.GetSiteCollection, "getSiteCollection"],
  [FunctionName.GetSubfolders, "getSubfolders"]
]);
